import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import MobilePage from '@src/assets/images/background-intro-mobile.png';

const StyledMobilePage = styled('div')`
  background-image: url(${MobilePage});
  background-repeat: no-repeat;
  padding: 40px;
  display: flex;
  gap: ${(props) => (props?.openSidebar ? '30px' : '120px')};
  justify-content: center;
  gap: 30px;
  background-size: cover;
  min-height: 88vh;
  align-items: center;
  border-radius: 16px;

  .mobile-app-content {
    width: 100%;
    max-width: 465px;
  }

  .tag {
    color: ${COLOR.darkGray};
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    word-wrap: break-word;
    text-transform: uppercase;
  }

  .title {
    color: ${COLOR.darkGray};
    font-size: 48px;
    font-weight: 900;
    line-height: 64px;
    word-wrap: break-word;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .content {
    color: rgba(28, 28, 30, 0.64);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
    margin-bottom: 48px;
  }

  .description {
    padding-bottom: 0;
    padding-top: 0;
  }

  .icon {
    color: ${COLOR.darkBlue};
    width: 10px;
    height: 10px;
  }

  .text-download {
    color: ${COLOR.black.default};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
  }

  .download-app {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-top: 8px;
  }

  .qr-code {
    width: 160px;
  }

  .download-button-container {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .download-button {
    padding: 0;
  }

  .phones-image {
    width: 100%;
    height: auto;
    max-width: 500px;
    max-height: 500px;
  }

  @media only screen and (max-width: 1024px) {
    display: flex;
    flex-direction: column-reverse;
    min-height: 93vh;
    gap: 0;
    padding: 16px;

    .iphones {
      max-width: 300px;
    }

    .content {
      margin-bottom: 24px;
    }

    .tag {
      font-size: 20px;
    }

    .title {
      font-size: 32px;
      line-height: 38px;
    }

    .download-app {
      gap: 0;
    }

    .qr-code {
      width: 150px;
    }

    .phones-image {
      margin-bottom: 16px;
    }
  }

  @media only screen and (min-width: 1440px) {
    .mobile-app-content {
      max-width: 480px;
    }

    .phones-image {
      max-width: 600px;
      max-height: 600px;
    }
  }

  @media only screen and (min-width: 1920px) {
    .mobile-app-content {
      max-width: 590px;
    }

    .phones-image {
      max-width: 750px;
      max-height: 750px;
    }
  }
`;

export { StyledMobilePage };
